import React from "react"
import { Modal, Button } from "antd"
import { EditOutlined, CloseOutlined } from "@ant-design/icons"
import { translations } from "../../utils/Translation/staticTranslation"
import "./Campaigns.css"

const ViewCampaignModal = ({
  visible,
  onClose,
  campaign,
  onEdit,
  onViewDetails,
  onViewStatistics,
  readOnly = false,
}) => {
  const lang = localStorage.getItem("language") || "ar"
  const t = translations[lang]?.campaignsPage
  if (!campaign) return null

  const originalData = campaign.originalData || campaign
  const emailBlock = originalData.email_block || {}

  // Check if status is Completed or Queue
  const status = (originalData.status || campaign.status || "").toLowerCase()
  const isCompleted = status === "completed"
  const isQueue = status === "queue"
  const isQueueOrCompleted = isCompleted || isQueue || 
    originalData.status === "Completed" || originalData.status === "Queue" ||
    campaign.status === "Completed" || campaign.status === "Queue"

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "—"
    try {
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, "0")
      const day = String(date.getDate()).padStart(2, "0")
      return `${year}-${month}-${day}`
    } catch {
      return "—"
    }
  }

  return (
    <Modal
      title={
        <div className="view-campaign-modal-header">
          <div className="view-campaign-modal-title-text">{t?.view_campaign || "View Campaign"}</div>
          <div className="view-campaign-modal-header-actions">
            <Button
              type="primary"
              onClick={onViewDetails}
              className="view-details-button"
            >
              {t?.buttons?.view_details || "View Details"}
            </Button>
            {isCompleted && onViewStatistics && (
              <Button
                type="default"
                onClick={onViewStatistics}
                className="view-status-button"
              >
                {t?.buttons?.view_status || (lang === "ar" ? "عرض الحالة" : "View Status")}
              </Button>
            )}
            {!isQueueOrCompleted && (
              <Button
                type="text"
                icon={<EditOutlined />}
                onClick={onEdit}
                className="view-campaign-edit-button"
                disabled={readOnly}
              >
                {t?.buttons?.edit || "Edit"}
              </Button>
            )}
            <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={onClose}
              className="view-campaign-close-button"
            />
          </div>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      width={700}
      className="view-campaign-modal"
      closeIcon={false}
    >
      <div className="view-campaign-modal-body">
        <div className="view-campaign-details-wrapper">
          <div className="view-campaign-row">
            <div className="view-campaign-label">{t?.view?.campaign || "Campaign"}</div>
            <div className="view-campaign-value">
              {originalData.title || "—"}
            </div>
          </div>

          <div className="view-campaign-row">
            <div className="view-campaign-label">{t?.view?.created_by || "Created by"}</div>
            <div className="view-campaign-value">
              {originalData.created_by_name_en ||
                originalData.created_by_name_ar ||
                "—"}
            </div>
          </div>

          <div className="view-campaign-row">
            <div className="view-campaign-label">{t?.view?.type || "Type"}</div>
            <div className="view-campaign-value">
              {originalData.type || "—"}
            </div>
          </div>

          <div className="view-campaign-row">
            <div className="view-campaign-label">{t?.view?.status || "Status"}</div>
            <div className="view-campaign-value">
              {originalData.status || "—"}
            </div>
          </div>

          <div className="view-campaign-row">
            <div className="view-campaign-label">{t?.view?.audience || "Audience"}</div>
            <div className="view-campaign-value">
              {lang === "ar" 
                ? (originalData.audience_preset_arabic || originalData.audience_preset || "—")
                : (originalData.audience_preset || "—")}
            </div>
          </div>

          <div className="view-campaign-row">
            <div className="view-campaign-label">{t?.view?.created_on || "Created on"}</div>
            <div className="view-campaign-value">
              {formatDate(originalData.time_created)}
            </div>
          </div>

          <div className="view-campaign-row-last">
            <div className="view-campaign-label">{t?.view?.description || "Description"}</div>
            <div className="view-campaign-value-description">
              {originalData.description || "—"}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ViewCampaignModal
